var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRobotHeart = function SvgRobotHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 937,
    height: 449,
    viewBox: "0 0 937 449"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#463D63",
    d: "M0 86.315h298v163.651H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#534B6E",
    d: "M7.902 66h33.864v33.859H7.902z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#342C51",
    d: "M0 261.253h298v32.73H0zm0 44.017h298V338H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#463D63",
    d: "M320 86.315h298v163.651H320z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#534B6E",
    d: "M327.902 66h33.864v33.859h-33.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#342C51",
    d: "M320 261.253h298v32.73H320zm0 44.017h298V338H320z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#463D63",
    d: "M639 86.315h298v163.651H639z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#534B6E",
    d: "M646.902 66h33.864v33.859h-33.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#342C51",
    d: "M639 261.253h298v32.73H639zm0 44.017h298V338H639z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#110737",
    d: "m558.263 154.49 141.893 51.645-45.83 125.919-141.894-51.645z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9 -443.054 3177.996)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.131,
    cy: 273.551,
    fill: "#534B6E",
    rx: 102.245,
    ry: 12.155,
    transform: "rotate(-8 111.131 273.55)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m163.683 210.423-6.472 40.86-81.806-12.956 6.472-40.86zM95.71 223.59l-8.765-1.388-1.387 8.756 8.765 1.388zm55.511 8.793-8.765-1.389-1.387 8.756 8.765 1.388zm-53.2-23.386-8.765-1.388-1.387 8.756 8.765 1.388zm55.511 8.793-8.765-1.389-1.386 8.756 8.765 1.388z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.924,
    height: 32.89,
    x: 6.792,
    y: 0.105,
    rx: 16.445
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.404,
    height: 24.379,
    x: 179.852,
    y: 204.396,
    rx: 12.189
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.795 57.342 8.572 2.297-9.178 34.252-8.572-2.297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.644 66.48 29.786 7.98-4.589 17.127-29.786-7.982zm197.151 52.826 37.145 9.953-4.589 17.126-37.145-9.953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.235 119.356 8.571 2.297-9.177 34.252-8.572-2.297zM262.9 71.39l-39.77 148.425-13.57-3.637c-.033-7.534-5.072-14.416-12.7-16.46-7.634-2.046-15.44 1.395-19.234 7.903l-160.22-42.93 39.77-148.424L262.9 71.391zm-152.027 54.576-3.94-1.056c-13.706-3.666-24.005-6.347-25.416-6.508-8.244 29.052 11.017 52.985 39.117 60.514s59.625-3.616 67.235-32.017c-5.155-1.381-28.849-7.887-52.584-14.334l-2.966-.805a8257 8257 0 0 0-21.446-5.794m-16.93-56.34c-6.872-1.842-13.929 2.233-15.769 9.099a12.9 12.9 0 0 0-.4 4.373l23.429 6.277a12.9 12.9 0 0 0 1.84-3.987c1.84-6.866-2.235-13.923-9.1-15.762m106.665 27.138-.025-.007c-6.503-1.742-13.186 2.117-14.929 8.62a12.13 12.13 0 0 0-.03 6.2l20.529 5.501a12.13 12.13 0 0 0 3.074-5.385c1.742-6.503-2.117-13.187-8.62-14.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.497,
    height: 8.865,
    x: 109.559,
    y: 262.717,
    rx: 4.432,
    transform: "rotate(-9 127.307 267.15)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A7E",
    fillRule: "nonzero",
    d: "M575.29 28.09c-9.204-17.922-31.188-24.988-49.11-15.783a36.4 36.4 0 0 0-8.777 6.306l-4.733 4.328-4.583-4.173A36.14 36.14 0 0 0 476.566 8.76a35.87 35.87 0 0 0-26.517 19.324c-7.032 13.782-4.317 30.535 6.706 41.39l51.942 53.511a5.54 5.54 0 0 0 7.836.11l.11-.11 51.87-53.41a35.54 35.54 0 0 0 6.778-41.485z"
  }))));
};
export default SvgRobotHeart;